module.exports = __webpack_public_path__ + "img/android-chrome-512x512.c46b7320.png";